<script lang="ts">
	import { Icon } from '@repo/ui'
	import { SpinnerLoader } from '@repo/ui'
	import type { IconSource } from '@steeze-ui/heroicons'
	import type { MouseEventHandler } from 'svelte/elements'

	interface Props {
		href?: string | null
		icon?: IconSource | null
		iconRight?: boolean
		small?: boolean
		disabled?: boolean
		target?: string | null
		underline?: boolean
		label?: string | null
		name: string
		inline?: boolean
		download?: string
		loading?: boolean
		rel?: string
		onclick?: MouseEventHandler<HTMLAnchorElement>
		children?: import('svelte').Snippet
	}

	let {
		href = null,
		icon = null,
		iconRight = false,
		small = false,
		disabled = false,
		target = null,
		underline = true,
		label = null,
		name,
		inline = false,
		download = null,
		loading = false,
		rel = null,
		onclick = null,
		children,
	}: Props = $props()
</script>

<svelte:element
	this={href ? 'a' : 'button'}
	class="{inline ? 'inline' : 'inline-flex'} items-center {small
		? 'gap-1 text-sm'
		: 'gap-2.5'} {disabled
		? 'pointer-events-none text-gray-300'
		: 'text-primary-500'} dark:text-primary-400 {underline
		? 'underline hover:no-underline'
		: 'hover:underline'}"
	data-test={name}
	{download}
	{href}
	{onclick}
	{rel}
	role="link"
	tabindex="0"
	{target}
	type={href ? null : 'button'}
>
	{#if icon && !iconRight}
		{#if loading}
			<SpinnerLoader />
		{:else}
			<Icon {small} src={icon} />
		{/if}
	{/if}
	<span>
		{#if children}{@render children()}{:else}
			{label}
		{/if}
	</span>
	{#if icon && iconRight}
		{#if loading}
			<SpinnerLoader />
		{:else}
			<Icon {small} src={icon} />
		{/if}
	{/if}
</svelte:element>
